import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { apiFetch } from "../../api.js";
import Layout from "../../components/Layout.js";
import Select from "react-select";

const FinanceMasterDetailsDesign = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const allowNumbers = (value) => value.replace(/[^0-9]/g, "");
  const [Financer, setFinancer] = useState("");
  const [Financerlist, setFinancerlist] = useState([]);
  const [Effectivefrom, setEffectivefrom] = useState("");
  const [Closingdate, setClosingdate] = useState("");
  const [Financeamountfrom, setFinanceamountfrom] = useState("");
  const [Financeamountto, setFinanceamountto] = useState("");
  const [Payoutpercentage, setPayoutpercentage] = useState("");
  const [errors, setErrors] = useState({});
  const [isEditMode, setIsEditMode] = useState(false);
  const [ipAddress, setIpAddress] = useState("");
  const [userId, setUserId] = useState("");
  const [serverIp] = useState(window.location.hostname);
  const storedUserInfo = JSON.parse(sessionStorage.getItem("userinfo")) || {};
  const [gridRows, setGridRows] = useState([]);
  const allowDecimal = (value) => {
    return value.replace(/[^0-9.]/g, "").replace(/(\..*)\./g, "$1");
  };

  const inputStyle = (error) => ({
    padding: "12px 15px",
    height: "45px",
    marginTop: "5px",
    borderRadius: "6px",
    border: error ? "2px solid red" : "1px solid #ccc",
    width: "100%",
    fontSize: "15px",
    boxSizing: "border-box",
    backgroundColor: "#fff",
  });

  const buttonContainerStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "14px",
    flexWrap: "nowrap", // 🔥 no wrapping (forces one row)
    width: "100%",
    marginTop: "30px",
    position: "relative",
    zIndex: 10,
  };

  const buttonStyle = (bgColor) => ({
    minWidth: "120px",
    height: "44px",
    padding: "0 18px",
    backgroundColor: bgColor,
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    fontWeight: "bold",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    whiteSpace: "nowrap",
  });
  useEffect(() => {
    const storedUserInfo = JSON.parse(sessionStorage.getItem("userinfo")) || {};
    setUserId(storedUserInfo.userId || "");
  }, []);

  useEffect(() => {
    apiFetch("/api/get-ip")
      .then((res) => res.json())
      .then((data) => setIpAddress(data.ip))
      .catch(() => setIpAddress("0.0.0.0"));
  }, []);

  const handleExit = () => {
    navigate("/FinanceMasterGrid");
  };

  //-----------------------------------Add Button Working
  const handleAddRow = () => {
    if (!Financeamountfrom || !Financeamountto || !Payoutpercentage) {
      alert("Please fill all fields");
      return;
    }
    if (+Financeamountfrom >= +Financeamountto) {
      alert("From amount must be less than To amount");
      return;
    }
    setGridRows([
      ...gridRows,
      {
        Financeamountfrom: +Financeamountfrom,
        Financeamountto: +Financeamountto,
        Payoutpercentage: +Payoutpercentage,
        unq: null,
      },
    ]);
    setFinanceamountfrom("");
    setFinanceamountto("");
    setPayoutpercentage("");
  };

  useEffect(() => {
    fetchFinance();
  }, []);
  //-----------------------------------Fetch Finance
  const fetchFinance = async () => {
    try {
      const response = await apiFetch(
        "/api/finance/fetchfinance",
        { method: "POST", body: JSON.stringify({}) },
      );
      const data = await response.json();
      if (data?.err === 0) {
        const list = (data.data || []).map((x) => ({
          value: x.value,
          label: x.data,
        }));
        setFinancerlist(list);
      } else {
        console.warn("API Error:", data);
      }
    } catch (error) {
      console.error("Error fetching finance:", error.message);
    }
  };
  //-----------------------------------Save Working
  const handleSave = async () => {
    if (!Financer || !Effectivefrom || !Closingdate) {
      alert("Please fill all required fields");
      return;
    }
    if (gridRows.length === 0) {
      alert("Please add at least one finance slab");
      return;
    }
    try {
      const masterResponse = await apiFetch(
        "/api/finance/save-master",
        {
          method: "POST",
          body: JSON.stringify({
            userid: userId,
            ipadd: ipAddress,
            financeid: Financer,
            effectivedate: Effectivefrom,
            closingdate: Closingdate,
          }),
        },
      );
      const masterRes = await masterResponse.json();
      if (masterRes.err !== "0") {
        alert(masterRes.msg);
        return;
      }
      const parentUnqid = masterRes.unqid;
      for (const row of gridRows) {
        await apiFetch("/api/finance/save-child", {
          method: "POST",
          body: JSON.stringify({
            parentunq: parentUnqid,
            payoutfrom: row.Financeamountfrom,
            payoutto: row.Financeamountto,
            payoutpercentage: row.Payoutpercentage,
          }),
        });
      }
      alert("Finance Master saved successfully");
      navigate("/FinanceMasterGrid");
    } catch (err) {
      console.error(err);
      alert("Server error");
    }
  };
  //-----------------Edit Code
  useEffect(() => {
    if (location.state?.unqid) {
      setIsEditMode(true);
      loadEditData(location.state.unqid);
    }
  }, [location.state]);
  const loadEditData = async (unqid) => {
    try {
      const masterResponse = await apiFetch(
        "/api/finance/edit-master",
        { method: "POST", body: JSON.stringify({ unqid }) },
      );
      const masterRes = await masterResponse.json();
      if (masterRes?.unqid) {
        setFinancer(masterRes.financeid);
        setEffectivefrom(masterRes.fromdate.split("-").reverse().join("-"));
        setClosingdate(masterRes.todate.split("-").reverse().join("-"));
      }
      const childResponse = await apiFetch(
        "/api/finance/edit-child",
        { method: "POST", body: JSON.stringify({ parentunq: unqid }) },
      );
      const childRes = await childResponse.json();
      if (childRes?.err === 0) {
        setGridRows(
          childRes.data.map((x) => ({
            Financeamountfrom: x.from,
            Financeamountto: x.to,
            Payoutpercentage: x.percentage,
            unq: x.unqid,
          })),
        );
      }
    } catch (err) {
      console.error("Edit load error", err);
    }
  };
  //-----------------Update Code
  const handleUpdate = async () => {
    try {
      await apiFetch("/api/finance/update-master", {
        method: "POST",
        body: JSON.stringify({
          unqid: location.state.unqid,
          financeid: Financer,
          effectivedate: Effectivefrom,
          closingdate: Closingdate,
        }),
      });
      for (const row of gridRows) {
        if (row.unq) {
          await apiFetch(
            "/api/finance/update-child",
            {
              method: "POST",
              body: JSON.stringify({
                parentunq: location.state.unqid,
                payoutfrom: row.Financeamountfrom,
                payoutto: row.Financeamountto,
                payoutpercentage: row.Payoutpercentage,
              }),
            },
          );
        } else {
          await apiFetch(
            "/api/finance/save-child",
            {
              method: "POST",
              body: JSON.stringify({
                parentunq: location.state.unqid,
                payoutfrom: row.Financeamountfrom,
                payoutto: row.Financeamountto,
                payoutpercentage: row.Payoutpercentage,
              }),
            },
          );
        }
      }
      alert("Finance Master updated successfully");
      navigate("/FinanceMasterGrid");
    } catch (err) {
      console.error(err);
      alert("Update failed");
    }
  };

  return (
    <Layout>
      <div className="page-container">
        <div className="container">
          <div className="header">Finance Master</div>

          {/* Form Section */}
          <div className="form-row">
            <div className="form-column">
              <label>Financer</label>
              <Select
                options={Financerlist}
                value={Financerlist.find((o) => o.value === Financer) || null}
                onChange={(selected) =>
                  setFinancer(selected ? selected.value : "")
                }
                placeholder="Select Financer"
                isSearchable
                styles={{
                  control: (base) => ({
                    ...base,
                    minHeight: "45px",
                    borderRadius: "6px",
                    borderColor: errors.financer ? "red" : "#ccc",
                    fontSize: "15px",
                  }),
                }}
              />
            </div>
            <div className="form-column">
              <label>Effective From</label>
              <input
                type="date"
                value={Effectivefrom}
                onChange={(e) => setEffectivefrom(e.target.value)}
                style={inputStyle()}
              />
            </div>
            <div className="form-column">
              <label>Closing Date</label>
              <input
                type="date"
                value={Closingdate}
                onChange={(e) => setClosingdate(e.target.value)}
                style={inputStyle()}
              />
            </div>

            <div className="form-column">
              <label>Finance Amount From</label>
              <input
                type="text"
                value={Financeamountfrom}
                onChange={(e) =>
                  setFinanceamountfrom(allowDecimal(e.target.value))
                }
                style={inputStyle(errors.Financeamountfrom)}
              />
            </div>
            <div className="form-column">
              <label>Finance Amount To</label>
              <input
                type="text"
                value={Financeamountto}
                onChange={(e) =>
                  setFinanceamountto(allowDecimal(e.target.value))
                }
                style={inputStyle(errors.Financeamountto)}
              />
            </div>
            <div className="form-column">
              <label>Payout Percentage</label>
              <input
                type="text"
                value={Payoutpercentage}
                onChange={(e) =>
                  setPayoutpercentage(allowDecimal(e.target.value))
                }
                style={inputStyle(errors.Category)}
              />
            </div>
            <div className="form-column" style={{ marginTop: "22px" }}>
              <button type="button" className="btn-add" onClick={handleAddRow}>
                Add
              </button>
            </div>
          </div>
          {/* ---------------- TABLE ---------------- */}
          <div className="table-container">
            <div className="container">
              <table>
                <thead>
                  <tr>
                    <th>Finance Amount From</th>
                    <th> Finance Amount To</th>
                    <th>Payout Percentage</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {gridRows.map((row, index) => (
                    <tr key={index}>
                      <td>{row.Financeamountfrom}</td>

                      <td>{row.Financeamountto}</td>

                      <td>{row.Payoutpercentage}</td>

                      <td>
                        <button
                          className="delete-btn"
                          onClick={() => {
                            const updated = gridRows.filter(
                              (_, i) => i !== index,
                            );
                            setGridRows(updated);
                          }}
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          {/* Buttons */}
          <div className="button-container">
            {!isEditMode && (
              <button style={buttonStyle("#4caf50")} onClick={handleSave}>
                Save
              </button>
            )}
            {isEditMode && (
              <button style={buttonStyle("#2e20abff")} onClick={handleUpdate}>
                Update
              </button>
            )}

            <button style={buttonStyle("#ab2025")} onClick={handleExit}>
              Exit
            </button>
          </div>
        </div>
      </div>

      <style>
        {`
        .page-container {
  width: 100%;
  min-height: 100vh;
  background: #f4f6f8;
  display: flex;
  justify-content: center;
  padding: 10px;
  box-sizing: border-box;
}

.container {
  width: 100%;
  max-width: 1200px;
  background: #fff;
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0 4px 8px rgba(0,0,0,0.1);
}

/* HEADER */
.header {
  text-align: center;
  font-size: 1.5rem;
  font-weight: bold;
  padding: 15px;
  background: #8B1E3F;
  color: #fff;
  border-radius: 6px;
  margin-bottom: 20px;
}

/* ===== RESPONSIVE FORM GRID ===== */
.form-row {
  display: grid;
  grid-template-columns: repeat(4, 1fr); /* desktop */
  gap: 16px;
  margin-bottom: 16px;
}

.form-column {
  display: flex;
  flex-direction: column;
}

/* ===== ADD BUTTON ===== */
.btn-add {
  background-color: #0b1e6d;
  color: #fff;
  height: 42px;
  min-width: 100px;
  padding: 0 20px;
  border: none;
  border-radius: 6px;
  font-weight: 600;
  cursor: pointer;
}

/* ===== TABLE ===== */
.table-container {
  overflow-x: auto;
  margin-top: 25px;
}

table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

th, td {
  border: 1px solid #ccc;
  padding: 8px;
  text-align: center;
}

thead tr {
  background: #ff353561;
}

.delete-btn {
  background: #c62828;
  color: white;
  border: none;
  padding: 6px 14px;
  border-radius: 5px;
  cursor: pointer;
}

/* ===== BUTTONS ===== */
.button-container {
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-top: 25px;
  flex-wrap: wrap;
}

.button-container button {
  min-width: 110px;
  padding: 12px 18px;
  border-radius: 6px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
}

/* ===== TABLET ===== */
@media (max-width: 1024px) {
  .form-row {
    grid-template-columns: repeat(2, 1fr);
  }
}

/* ===== MOBILE ===== */
@media (max-width: 600px) {
  .form-row {
    grid-template-columns: 1fr;
  }

  .button-container button {
    flex: 1;
  }
}

        `}
      </style>
    </Layout>
  );
};

export default FinanceMasterDetailsDesign;
